<template>
  <div class="form-wrap" v-if="showMark">
    <div class="form-main">
      <div class="form-tit">
        <div class="form-tit-double" v-if="formInfo.subName">
          <h3>{{ this.formInfo.itemName }}</h3>
          <p>{{ this.formInfo.subName }}</p>
        </div>
        <div class="form-tit-single" v-else>
          <h3>{{ this.formInfo.itemName }}</h3>
        </div>
        <div class="close" @click="cancel">
          <i class="iconfont icon-cha"></i>
        </div>
      </div>
      <div class="form-body">
        <!-- 基础表单项 -->
        <div class="form-item require">
          <p>姓名</p>
          <input
            type="text "
            class="hasicon"
            v-model="formData.fullName"
            @focus="focusFlag = 'fullName'"
          />
          <i
            class="iconfont icon-xingming"
            :style="
              focusFlag === 'fullName' ? 'color:#FDB8B8' : 'color:#E8E8E8'
            "
          ></i>
        </div>
        <div class="form-item require">
          <p>手机</p>
          <input
            type="text "
            class="hasicon"
            v-model="formData.phone"
            @focus="focusFlag = 'phone'"
          />
          <i
            class="iconfont icon-shouji-copy-copy"
            :style="focusFlag === 'phone' ? 'color:#FDB8B8' : 'color:#E8E8E8'"
          ></i>
        </div>
        <div class="form-item require">
          <p>公司</p>
          <input
            type="text "
            class="hasicon"
            v-model="formData.company"
            @focus="focusFlag = 'company'"
          />
          <i
            class="iconfont icon-gongsi"
            :style="focusFlag === 'company' ? 'color:#FDB8B8' : 'color:#E8E8E8'"
          ></i>
        </div>
        <div class="form-item require">
          <p>邮箱</p>
          <input
            type="text "
            class="hasicon"
            v-model="formData.email"
            @focus="focusFlag = 'email'"
          />
          <i
            class="iconfont icon-youxiang1"
            :style="focusFlag === 'email' ? 'color:#FDB8B8' : 'color:#E8E8E8'"
          ></i>
        </div>

        <!-- SDWAN -->
        <div class="form-item" v-if="formInfo.items.includes('description')">
          <p>项目需求概述</p>
          <textarea
            rows="3"
            cols="20"
            v-model="formData.description"
            @focus="focusFlag = ''"
          />
        </div>
        <!-- 参观机房 -->
        <div class="form-item" v-if="formInfo.items.includes('city')">
          <p>城市</p>
          <input type="text" v-model="formData.city" @focus="focusFlag = ''" />
        </div>
        <!-- 加入我们 -->
        <div class="form-item require" v-if="formInfo.items.includes('job')">
          <p>职位</p>
          <input type="text" v-model="formData.job" @focus="focusFlag = ''" />
        </div>
        <!-- 加入我们 -->
        <div class="form-item" v-if="formInfo.items.includes('introduction')">
          <p>公司业务简介</p>
          <textarea
            rows="3"
            cols="20"
            v-model="formData.introduction"
            @focus="focusFlag = ''"
          />
        </div>
        <div class="form-bot">
          <el-button class="sub" @click="submit" :loading="loading"
            >提交</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  created() {
    // let addaH = document.getElementsByClassName("form-wrap");
    // console.log(addaH);
    // addaH[0].style.height = document.documentElement.scrollHeight + "px";
  },
  data() {
    return {
      loading: false,
      showMark: false,
      focusFlag: "",
      formInfo: {
        itemName: "temp",
        subName: "",
        buType: 1,
        items: []
      },
      validator: {
        isEmil: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/, // 校验邮箱
        isPhoneNumber: /^1[3456789]\d{9}$/, // 手机号码验证
      },
      require: ['fullName', 'phone', 'company', 'email'],
      formData: {
        name: "",
        phone: "",
        company: "",
        email: "",
        description: "",
        city: "",
        job: "",
        introduction: ""
      }
    }
  },
  methods: {
    open(data) {
      this.formInfo = data;
      this.forbidenScroll();
      this.showMark = true;
    },
    cancel() {
      this.formData = {
        fullName: "",
        phone: "",
        company: "",
        email: "",
        description: "",
        city: "",
        job: "",
        introduction: ""
      }
      this.require = ['fullName', 'phone', 'company', 'email'];
      this.reScroll();
      this.loading = false;
      this.showMark = false;
      // 控制SDWAN固定窗口显示
      if (this.$parent.resetVideo) this.$parent.resetVideo()
    },
    submit() {
      this.loading = true;
      let param = {}
      let valid = true;
      let patternValid = true;
      // 添加额外必填参数
      if (this.formInfo.exReq) {
        this.formInfo.exReq.forEach(item => {
          this.require.push(item)
        });
      }
      param.buType = this.formInfo.buType;
      for (let i in this.formData) {
        let requireFlag = this.require.includes(i);
        // 必填且非空执行添加 必填为空返回不合法 非必填且非空执行添加
        if (requireFlag && this.formData[i]) {
          param[i] = this.formData[i];
        } else if (requireFlag && !this.formData[i]) {
          valid = false
        } else if (!requireFlag && this.formData[i]) {
          param[i] = this.formData[i];
        }
      }

      // 正则校验
      if (param.phone && !this.validator.isPhoneNumber.test(param.phone)) {
        this.$message.error('请输入正确的手机号。');
        patternValid = false;
      }
      if (param.email && !this.validator.isEmil.test(param.email)) {
        this.$message.error({ message: '请输入正确的邮箱地址。', offset: 60 });
        patternValid = false;

      }

      // console.log(param);

      if (valid && patternValid) {
        // 非空进行正则校验
        // console.log(param);
        this.dispatchExtend('subForm', param).then(
          res => {
            this.$notify({
              title: '成功',
              message: '您的表单已提交成功，感谢您的申请。',
              type: 'success'
            });
            this.cancel();
          },
          err => {
            this.cancel();
            this.$notify.error({
              title: '失败',
              message: '表单提交失败。'
            });
          })
      } else if (!valid) {
        this.$notify.error({
          title: '失败',
          message: '请保证表单必填信息完整。'
        });
        this.loading = false;
      } else if (!patternValid) {
        this.loading = false;

      }

    },
    forbidenScroll() {
      var html = document.getElementsByTagName("html");
      html[0].style.overflow = "hidden";
    },
    reScroll() {
      var html = document.getElementsByTagName("html");
      html[0].style.overflow = "auto";
    }
  }

}
</script>

<style lang="less" scoped>
@import "../style/variable.less";
@media screen and(min-width:@sm_min) {
  .form-wrap {
    width: 100%;
    height: 8000px;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    .form-main {
      width: 500px;
      background: #fff;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      box-shadow: 0px 2px 15px 1px rgba(39, 39, 39, 0.1);
      .form-tit {
        width: 500px;
        height: 90px;
        color: #fff;
        background-repeat: no-repeat;
        background-size: 500px 110px;
        background-position: center;
        background-image: url("../assets/main/form.png");
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        .form-tit-single {
          h3 {
            font-size: 24px;
          }
        }
        .form-tit-double {
          text-align: center;
          h3 {
            font-size: 22px;
            line-height: 40px;
          }
          p {
            font-size: 15px;
            line-height: 20px;
          }
        }
        .close {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #fff;
          padding-top: 1px;
          position: absolute;
          top: -10px;
          right: -9px;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          i {
            font-size: 12px;
            color: #9a9a9a;
          }
        }
      }
      .form-body {
        max-height: 500px;
        overflow: auto;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 20px 30px 0px 30px;
      }
      .form-bot {
        padding: 15px 30px;
        text-align: center;
        .sub {
          width: 130px;
          height: 40px;
          border: none;
          color: #fff;
          border-radius: 0;
          font-size: 16px;
          cursor: pointer;
          background: #d0121b;
          transition: 0.4s;
          &:hover {
            background: #f72d2d;
          }
        }
      }
      .form-item {
        position: relative;
        i {
          color: #e8e8e8;
          font-size: 16px;
          position: absolute;
          left: 8px;
          top: 34px;
        }
        p {
          line-height: 28px;
          position: relative;
        }
        margin-bottom: 12px;
      }
      .require {
        p {
          &:after {
            content: "*";
            color: #d0121b;
            position: absolute;
            top: 0;
            left: 30px;
          }
        }
      }
      .hasicon {
        padding: 6px 34px;
      }
    }
    input {
      height: 30px;
    }
    input,
    textarea {
      width: 430px;
      padding: 6px 10px;
      outline-style: none;
      border: 1px solid #e8e8e8;
      transition: 0.4s;
      &:focus {
        background: #fff5f4;
        border: 1px solid rgba(247, 45, 45, 0.3);
      }
    }
  }
}
@media screen and (min-width: @phone) and (max-width: @xs) {
  .form-wrap {
    width: 100%;
    height: 8000px;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    .form-main {
      width: 10rem;
      background: #fff;
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 1999;
      transform: translate(-50%, -50%);
      box-shadow: 0px 2px 15px 1px rgba(39, 39, 39, 0.1);
      .form-tit {
        width: 10rem;
        height: 90px;
        color: #fff;
        background-repeat: no-repeat;
        background-size: 500px 110px;
        background-position: center;
        background-image: url("../assets/main/form.png");
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        .form-tit-single {
          h3 {
            font-size: 24px;
          }
        }
        .form-tit-double {
          text-align: center;
          h3 {
            font-size: 22px;
            line-height: 40px;
          }
          p {
            font-size: 15px;
            line-height: 20px;
          }
        }
        .close {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          // background: #fff;
          padding-top: 1px;
          position: absolute;
          top: 0.1rem;
          right: 0.1rem;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          i {
            font-size: 12px;
            color: #fff;
          }
        }
      }
      .form-body {
        overflow: auto;
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 20px 30px 0px 30px;
      }
      .form-bot {
        padding: 15px 30px;
        text-align: center;
        .sub {
          width: 130px;
          height: 40px;
          border: none;
          color: #fff;
          border-radius: 0;
          font-size: 16px;
          cursor: pointer;
          background: #d0121b;
          transition: 0.4s;
          &:hover {
            background: #f72d2d;
          }
        }
      }
      .form-item {
        position: relative;
        i {
          color: #e8e8e8;
          font-size: 16px;
          position: absolute;
          left: 8px;
          top: 55%;
          // transform: translateY(-20%);
        }
        p {
          line-height: 28px;
          position: relative;
        }
        margin-bottom: 12px;
      }
      .require {
        p {
          &:after {
            content: "*";
            color: #d0121b;
            position: absolute;
            top: 0;
            left: 30px;
          }
        }
      }
      .hasicon {
        padding: 6px 34px;
      }
    }
    input {
      height: 1rem;
      position: relative;
    }
    input,
    textarea {
      width: 9rem;
      padding: 6px 10px;
      outline-style: none;
      border: 1px solid #e8e8e8;
      transition: 0.4s;
      &:focus {
        background: #fff5f4;
        border: 1px solid rgba(247, 45, 45, 0.3);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/form.vue